import * as React from "react"
import type { SVGProps } from "react"
const SvgLongArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M16.15 13.14H5a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71q0-.42.29-.71a1 1 0 0 1 .71-.29h11.15L13.3 8.29a1 1 0 0 1-.28-.7q0-.4.28-.7.3-.3.72-.31a1 1 0 0 1 .7.29l4.58 4.57q.15.14.22.33a1 1 0 0 1 0 .75 1 1 0 0 1-.22.32l-4.57 4.57q-.3.3-.71.29a1 1 0 0 1-1-1.01 1 1 0 0 1 .28-.7z" />
  </svg>
)
export default SvgLongArrowRight
